import * as PROJECT_CODE from '../../../constants/projectCode';

export default async function SaveClientSignatureRequestInfo(
	firebase,
	unclaimedDraftJson,
	thisClientEmail,
	subjectName,
	clientCreatorId,
	leadId
) {
	console.log(
		'SaveClientSignatureRequestInfo params',
		firebase,
		unclaimedDraftJson,
		thisClientEmail,
		subjectName,
		clientCreatorId,
		leadId
	);

	var currentUserId;
	if (
		clientCreatorId !== null &&
		clientCreatorId !== undefined &&
		clientCreatorId !== ''
	) {
		console.log('SaveClientSignatureRequestInfo not null', clientCreatorId);
		currentUserId = clientCreatorId;
	} else {
		console.log(
			'SaveClientSignatureRequestInfo current user',
			clientCreatorId
		);
		currentUserId = firebase.auth().currentUser.uid;
	}

	var finalRef = firebase
		.database()
		.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/documentInformation/signatureRequests'
		);

	var newSignatureRequest = finalRef.push();

	unclaimedDraftJson['timestamp'] = Date.now();
	unclaimedDraftJson['subject'] = subjectName;

	newSignatureRequest.set(unclaimedDraftJson);
}
